import { render, staticRenderFns } from "./servicoAgendado.vue?vue&type=template&id=5b39558a&scoped=true"
import script from "./servicoAgendado.vue?vue&type=script&lang=js"
export * from "./servicoAgendado.vue?vue&type=script&lang=js"
import style0 from "./servicoAgendado.vue?vue&type=style&index=0&id=5b39558a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39558a",
  null
  
)

export default component.exports